// extracted by mini-css-extract-plugin
module.exports = {"add":"add__1ood3","buttonsGroup":"buttonsGroup__2NlE-","buttonsContainer":"buttonsContainer__9KCXe","textarea":"textarea__2Zuzd","box":"box__2EHdw","title":"title__3ESkk"};